// extracted by mini-css-extract-plugin
module.exports = {"chart":"Forecast_chart__2e4j-","loading":"Forecast_loading__1tZ9d","error":"Forecast_error__2OE-c"};